import React from 'react';
import PropTypes from 'prop-types';
import { store } from '../../store';
import { first, last } from 'lodash';
import ReactFileReader from 'react-file-reader';
import { ImageCrop } from 'ui-components';
import { setMessage } from '../../actions/systemMessage';

export default class ProfilePic extends React.Component {
  state = {
    uncroppedImages: []
  }

  imageToState = images => {
    this.setState({
      uncroppedImages: []
    });
  }

  setProfileImage = image => {
    this.setState({ uncroppedImages: [image, image] })
  }

  persistProfileImage = images => {
    this.props.vendor.$setProfileImage(first(images), this.props.profileType, 'profile-wide')
      .catch(err => store.dispatch(setMessage('error', 'There was a problem saving your profile image.')));

    this.props.vendor.$setProfileImage(last(images), this.props.profileType, 'profile')
      .catch(err => store.dispatch(setMessage('error', 'There was a problem saving your profile image.')));
  }

  render() {
    const { customer, vendor } = this.props;
    const imageCrops = [{
      x: 0,
      y: 0,
      width: 255,
      height: 424,
      aspect: 5/8
    }, {
      x: 0,
      y: 0,
      width: 540,
      height: 424,
      aspect: 6/5
    }];

    let readerDOM;
    if (this.props.view === 'header') {
      readerDOM = <div>
        {customer.get('loading').get('profilePic') && <div>loading...</div>}
        <img src={vendor.profilePicUrl('w_400,h_400,c_crop,g_face,r_max/w_175,h_175', this.props.profileType)} alt="profile" />
      </div>;
    } else if (this.props.view === 'link') {
      readerDOM = this.props.children || <span>Change Profile Pic</span>;
    }
    // else if (this.props.view === 'sidebar') {
    //   readerDOM = <div className="listing-image-basic-container">
    //     <div className="listing-image-placeholder">
    //       {!customer.get('loading').get('profilePic') &&
    //         <div className='profile-image'>
    //           {/*<i className='fa fa-2x fa-close' onClick={this.deleteProfileImage}/>*/}
    //           <i className='fa fa-2x fa-camera' />
    //           <img src={vendor.profilePicUrl(null, this.props.profileType)} alt='profile' />
    //         </div>}

    //       {customer.get('loading').get('profilePic') &&
    //         <div className="listing-image-placeholder-content text-center p-1 py-sm-3 px-sm-2 p-lg-3">
    //           <i className="fa fa-2x fa-circle-o-notch slow-spin" aria-hidden="true"></i>
    //           <span className="sr-only">Loading...</span>
    //         </div>}
    //       {!customer.get('loading').get('profilePic') &&
    //         <div className="listing-image-placeholder-content text-center p-1 py-sm-3 px-sm-2 p-lg-3">
    //         <i className="icon fa fa-camera mb-3 pb-3" aria-hidden="true"></i>
    //         <div className="h4 font-weight-light mb-sm-3 mb-lg-4">Upload Photo</div>
    //         <div>Photo will be used as your Listing profile photo</div>
    //       </div>}
    //     </div>
    //   </div>;
    // }

    return <div className={this.props.className || null}>
      <ReactFileReader base64={true} handleFiles={this.setProfileImage}>
        {readerDOM}
      </ReactFileReader>

      <ImageCrop
        {...this.props}
        messages={[
          'Please set a portrait version of your profile',
          'Please set a landscape version of your profile'
        ]}
        crop={imageCrops}
        persist={true}
        stateCallback={this.imageToState}
        persistCallback={this.persistProfileImage}
        uncroppedImages={this.state.uncroppedImages} />
    </div>;
  }
}

ProfilePic.defaultProps = {
  profileType: 'users'
}

ProfilePic.propTypes = {
  className: PropTypes.string,
  customer: PropTypes.object.isRequired,
  profileType: PropTypes.string,
  vendor: PropTypes.object.isRequired,
  view: PropTypes.string.isRequired
};



// WEBPACK FOOTER //
// ./src/components/User/ProfilePic.js